import { Alert, Container } from "react-bootstrap";

const Chat = () => {
    return (

        <Container className="mt-5 mb-5">

            <h1 className="mb-5">Chat with users.</h1>

            <Alert variant="success">
                Chat feature will appear here. 
            </Alert>

        </Container>

    );
}
 
export default Chat;